import state from '../cyclecount/state'
import mutations from '../cyclecount/mutations'
import actions from '../cyclecount/actions'
import getters from '../cyclecount/getters'

const appstatus = {
  firestorePath: '/appstatus',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'appstatus',
  statePropName: 'appstatus',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions

  state, getters, mutations, actions
}

export default appstatus